<template>
  <div class="recurrence-field align-top">
    <div class="field" @click="showList">
      <div class="legend legend--bottom-margin">
        {{ $t('message.RECURRENCE') }}
      </div>
      <div>
        <div class="recurrence-field__info v-centerer">
          <Icon>{{ problemsMedium }}</Icon>
          <span v-if="nDuplicates > 0">
            {{ $tc('message.RECURRENCE_N_DUPLICATE', nDuplicates, { nb: nDuplicates }) }}
          </span>
          <span v-else>
            {{ $tc('message.RECURRENCE_N_RELATED', nRelated, { nb: nRelated }) }}
          </span>
        </div>
      </div>
    </div>
    <!-- Display similar problems -->
    <transition name="fade" mode="out-in">
      <div v-if="listDisplayed" class="dark-overlay v-centerer" @click="closeList">
        <div class="dark-overlay-content large" @click.stop="">
          <CloseButton @click.native="closeList" />
          <SimilarProblemsList
            ref="list"
            :problem="problem"
            :recurrence-ids="recurrenceIds"
            :link-ids="linkIds"
            @pictureClick="(p, idx) => $emit('pictureClick', p, idx)"
            @sheetEdit="(field, val) => $emit('sheetEdit', field, val)"
            @tick="problemLinkTicked"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * Field of the problem sheet that allows the user to edit problems links
 *
 * @vue-prop {Object} problem - PRoblem that this field relates to
 *
 * @vue-event {String, *} sheetEdit - Trasmitted from ProblemDataSection
 * @vue-event {Object} pictureClick - Trasmitted from ProblemDataSection
 */

// Components
import CloseButton from '@/components/close-button.vue';
import Icon from '@/components/icon.vue';
import SimilarProblemsList from '@/components/problem-sheet/similar-problems-list.vue';
// Import socket handling utils
import mixinSocketHandler from '@/mixins/socket-handler.vue';
import SocketMessages from '@/utils/classes/SocketMessages';
// Import assets
import { problemsMedium } from '@/assets/icons';

export default {

  name: 'RecurrenceField',

  components: {
    CloseButton,
    Icon,
    SimilarProblemsList,
  },

  mixins: [mixinSocketHandler],

  props: {
    problem: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },

  data() {
    return {
      problemsMedium,
      listDisplayed: false,
      linkIds: [],
      recurrenceIds: [],
    };
  },

  computed: {
    nDuplicates() {
      return this.recurrenceIds.length;
    },
    nRelated() {
      return this.linkIds.length;
    },
  },

  mounted() {
    this.getLinks();
    this.handleSocketMessage(SocketMessages.CC_MSGS.PROBLEM_LINKS, (msg) => {
      if (Number(msg.id) === Number(this.problem.id)) {
        this.getLinks();
      }
    });
  },

  methods: {
    getLinks() {
      if (!this.problem.id || this.problem.id === '0') {
        return;
      }
      this.$http.post('/server/problems/links/get.php', { id: this.problem.id }).then(({ data }) => {
        if (data instanceof Object) {
          this.linkIds = data.linkIds;
          this.recurrenceIds = data.recurrenceIds;
          if (this.listDisplayed) {
            this.$nextTick(this.$refs.list.linksUpdated);
          }
        }
      });
    },
    /** A problem was (un)ticked */
    problemLinkTicked() {
      this.getLinks();
    },
    /** Display the list of similar problems */
    showList() {
      if (this.disabled) {
        return;
      }
      this.listDisplayed = true;
    },
    /** Hide the list of similar problems */
    closeList() {
      this.listDisplayed = false;
    },
  },
};
</script>

<style lang="scss">
.recurrence-field {
  .dark-overlay {
    cursor: initial;
  }
  .dark-overlay .dark-overlay-content.large {
    width: 80%;
    height: 80%;
    background: #f4f4f4;
    padding: 0px;
    overflow: hidden;
  }

  &__info {
    .icon {
      width: 1.1rem;
      height: 1.1rem;
      margin-right: .5rem;
    }
  }
}
</style>
